/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Guest_EditInputs */

const vi_meeting_guest_edit = /** @type {(inputs: Meeting_Guest_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sửa khách mời`)
};

/**

* @param {Meeting_Guest_EditInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const meeting_guest_edit = /** @type {((inputs?: Meeting_Guest_EditInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Guest_EditInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_meeting_guest_edit(inputs)
});